// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"navigation-tabs_tabsWrapper__u7u84"};